import type { PatchAssetStateRequest } from './assetPatchState';
import apiRequest from './apiRequest';

export default async function patchProjectByID(
  apiKey: string,
  projectID: string,
  body: PatchAssetStateRequest,
) {
  return apiRequest<Record<string, never>>(
    'external-mogen',
    `/projects/${encodeURIComponent(projectID)}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey,
      },
      body: JSON.stringify(body),
    },
  );
}
